<template>
  <transition name="eu-slide-fade-left">
    <section v-show="showComponent" class="la-wrapper pagarme">
      <section class="la-unification__highlight">
        <div class="la-container eu-ml_auto eu-mr_auto la-unification__bg">
          <div class="la-container__image _bg_1"></div>
          <div class="la-container__image _bg_2"></div>
        </div>
        <div class="la-bounds eu-pt_6 eu-no-pt_mobile">
          <div class="eu-flex eu-column eu-row_md eu-pb_4">
            <div class="eu-flex-item eu-basis_12 eu-basis_5_lg eu-basis_6_xl">
              <div class="la-unification__highlight__img">
                <emd-mundi-pagarme-unification-img class="eu-ml_auto eu-mr_auto eu-display_block" :isDark="isDark" />
              </div>
            </div>
            <div class="eu-flex-item eu-basis_12 eu-basis_9_md eu-basis_5_lg eu-ml_auto eu-mr_auto">
              <div class="la-title-container">
                <h1 class="la-title _tertiary eu-fluid_h2">Pagar.me e Mundipagg: unificação que evolui o seu negócio</h1>
              </div>
              <div class="la-lead-container">
                <p class="la-text emd-text eu-mb_4 _type_caption">
                  É com muito orgulho que anunciamos que a Mundipagg agora é parte do Pagar.me.
                </p>
                <p class="la-text">
                  A nossa plataforma agora ainda mais completa, oferecendo o melhor das duas soluções em uma experiência unificada. Quer saber mais detalhes sobre essa novidade? Criamos um FAQ na nossa Central de Atendimento, para que você fique por dentro de toda a incorporação.
                </p>
                <div class="la-button-area la-unification__button-area eu-mb_4">
                  <button @click="$emit('openFaq')" class="emd-btn la-unification__highlight__btn _color_primary _type_outline">
                    Quero saber mais
                  </button>
                  <button @click="$emit('click')" class="emd-btn la-unification__highlight__btn _color_primary">
                    Prosseguir
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  </transition>
</template>

<script>
import emdMundiPagarmeUnificationImg from './childrenComponents/emdMundiPagarmeUnificationImg.vue'
import 'emerald-workbench/dist/mundi.unification.min.css'
export default {
  name: 'EmdUnification',
  components: {
    emdMundiPagarmeUnificationImg
  },
  props: {
    isDark: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showComponent: false
  }),
  computed: {
    classList () {
      const classList = []
      if (this.isDark) classList.push('la-unification_dark-mode')
      else classList.push('la-unification_light-mode')
      return classList
    }
  },
  created () {
    setImmediate(function () { this.showComponent = true })
  }
}
</script>
